import React from 'react'

function Footer(props) {


  return (
    <div className={"p-6 pt-24 text-center text-sm " + props.transition}>
  &copy; <span className="roboto-slab-ttl">MATCH POINT SERVICE</span> 2025 &bull; <a className="link" href="/legal">Legal</a> <br/> <a style={{color:'#999',letterSpacing: '0.2px'}} className="text-sm pb-2 pt-2.5" href="https://remiblot.com">Crafted by Rémi Blot</a>
  <br/>

</div>
  )
}

export default Footer
